import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { UrlServidor } from "../util/url-servidor";
import { Observable } from "rxjs";
import { PageResponse } from "../api/dto/paginacao/page-response";
import { MonitoramentoJob } from "../api/dto/monitoramento-job";
import { Job } from "../api/dto/job";

@Injectable({
    providedIn: 'root'
})
export class JobService{

    constructor(private http: HttpClient) {}

    private url: string = UrlServidor.URL_BASE + 'jobs';


    processar(job: any): Observable<void> {
        return this.http.post<void>(`${this.url}/processar`, job);
    }


    listar(jobName?: string, page?: number, size?: number, sort?: string,
        dataInicio?: Date, dataFim?: Date
    ): Observable<PageResponse<MonitoramentoJob>> {
        let parametros = new HttpParams();
        if (jobName) {
            parametros = parametros.set('nomeJob', jobName);
        }
        if (page) {
            parametros = parametros.set('page', page);
        }
        if (size) {
            parametros = parametros.set('size', size);
        }
        if (sort) {
            parametros = parametros.set('sort', sort);
        }
        if (dataInicio) {
            parametros = parametros.set('dataInicio', dataInicio.toISOString());
        }
        if (dataFim) {
            parametros = parametros.set('dataFim', dataFim.toISOString());
        }

        return this.http.get<PageResponse<MonitoramentoJob>>(this.url, {params: parametros});
    }

    listarPorNomeEData(nome?: string, data?: Date): Observable<Job[]> {
        return this.http.get<Job[]>(`${this.url}/${nome}/data/${data}`);
    }

}